import initPipelines from '../init_pipelines';

document.addEventListener('DOMContentLoaded', initPipelines);
